<style src="./style.scss">
</style>

<script lang="ts">
  import { afterUpdate, onMount } from "svelte";

  import Icon from "svelte-icon";

  import Button from "@components/button";
  import Header from "@components/header";
  import Footer from "@components/footer";
  import Spinner from "@components/spinner";
  import Sidebar from "@components/sidebar";
  import { navigate, useLocation } from "svelte-navigator";
  import { query, mutation } from "svelte-apollo";
  import { formatCurrency } from "@utils";
  import { getEmail, removeToken, getToken } from "@services/auth";

  import { SUBSCRIPTION_QUERY } from "./subscription.query.ts";

  export let matchs = null;

  const location = useLocation();

  let subscription;
  let isLoading = true;
  let status = {};
  let showToastMessage = false;
  let toastMessage = "";
  let isMatchPage = false;
  let currentPage = null;

  const email = getEmail();

  const subscriptionQuery = query(SUBSCRIPTION_QUERY, {
    variables: {},
    skip: true,
  });

  const token = getToken();

  afterUpdate(async () => {
    currentPage = $location.pathname;
    isMatchPage = matchs.some((page) => currentPage === page);

    if (!subscription && isMatchPage && token) {
      await subscriptionQuery.refetch();

      isLoading = false;

      if ($subscriptionQuery) {
        if ($subscriptionQuery?.data?.subscription !== null) {
          subscription = $subscriptionQuery?.data?.subscription;
        }
        if ($subscriptionQuery?.data?.subscription === null) {
          removeToken();
          navigate("/");
        }
      }
      return;
    }

    isLoading = false;
  });
</script>

{#if isLoading}
  <Spinner />
{:else if isMatchPage}
  <Header />

  <div class="page-template">
    <div class="page-template__content">
      <Sidebar
        hideUnsubiscribeOption="{subscription?.status === 'CANCELED' ||
          subscription?.status === 'REFUNDED'}"
        promotionCode="{subscription?.promotionCode}"
        billingProvider="{subscription?.provider}"
        bind:currentPage
        state="{{
          remainingDays: subscription?.remainingDays,
          nextPaymentDate: subscription?.nextPaymentDate,
          endAt: subscription?.endAt,
        }}" />
      <div class="page-template__content__slot">
        <slot />
      </div>
    </div>

    <div class="desktop-only">
      <Footer />
    </div>
  </div>
{:else}
  <slot />
{/if}
